import { type AppThunk } from "../../../index";
import { clearActivities } from "../../traineeActivities/reducer";
import { clearMealsPlan } from "../../traineeMealsPlans/reducer";
import { clearMeasurements } from "../../traineeMeasurements/reducer";
import { resetFetchedWeek } from "../../traineeNutritionTracker/reducer";
import { clearFetchedProgram } from "../../traineeProgram/reducer";
import { clearSurveys } from "../../traineeSurveys/reducer";
import { clearTrainerProfile as action } from "../reducer";
import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromTrainee =
  (): AppThunk =>
  async (dispatch, _, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "trainee");

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeTraineeChannel;
    subscriptions.realtimeTraineeChannel = null;
    subscriptions.traineeChannelName = null;
    void closeRealtimeChannel(db, channel);
    dispatch(clearActivities());
    dispatch(clearFetchedProgram());
    dispatch(clearMealsPlan());
    dispatch(clearMeasurements());
    dispatch(resetFetchedWeek());
    dispatch(action());
    dispatch(clearSurveys());
  };
